<template>
	<!-- Main Sidebar Container -->
	<aside class="main-sidebar sidebar-dark-primary elevation-4">
		<!-- Brand Logo -->
		<router-link to="/dashboard" class="brand-link">
			<img src="@/assets/images/logo-tpsd.png" alt="logo" class="brand-image img-circle elevation-3">
			<span class="brand-text font-weight-light text-home">TRANG CHỦ</span>
		</router-link>
		<!-- Sidebar -->
		<TheTreeMenu v-if="items" :treeData="items"></TheTreeMenu>
		<!-- /.sidebar -->
	</aside>
</template>

<script>
	import TheTreeMenu from '@/components/dashboard/TheTreeMenu.vue';

	export default {
		name: 'TheSideBar',
		components: {
			TheTreeMenu
		},
		data() {
			return {
				isBusy: false,
				items: []
			}
		},
		methods: {
			async getDataMenu() {
				let menu = JSON.parse(localStorage.getItem("menu"));
				this.items = menu ? menu : null
			}
		},
		async mounted() {
			await this.getDataMenu()
		}
	}
</script>

<style scoped>
	.text-home {
		font-weight: 500 !important;
		color: #fff;
	}
</style>